import React, {useEffect, useState} from "react";

// Reset di stile: il controllo era un <a class="page-link">, ora e' un <button>.
// La classe .page-link fornisce gia' sfondo, bordo, colore, padding e line-height:
// resta solo da neutralizzare il font proprio del button, perche' la resa grafica
// resti identica a prima.
const stilePageLink = {
    font: "inherit",
    cursor: "pointer"
}

function Pagination(props) {

    const [page, setPage] = useState(0)
    const [toRender, setToRender] = useState()

    useEffect(() => {
        createPagination()
    }, [props.pagination, props.disabled,props.pagination.page,props.pagination.totalPages,props.pagination.totalElements])

    function changePage(newPage) {
        if (props.pagination.totalPages) {
            if (newPage >= 0 && newPage < props.pagination.totalPages) {
                if (props.changePage) {
                    console.log("[DEBUG] Changing page to page: " + newPage);
                    props.changePage(newPage)
                    setPage(newPage)
                } else {
                    setPage(newPage)
                }
            } else console.log("[DEBUG] Invalid page: " + newPage);
        }
    }


    function createPagination() {
        let newPage = props.pagination.page !== page ? props.pagination.page : page
        let pagination = props.pagination
        let pageNumbers = []
        let totalPages = Math.ceil(pagination.totalPages)
        let lastPage = Math.floor(totalPages - 1)
        totalPages && pageNumbers.push(
            <li key={0} className={"page-item ".concat(props.disabled ? "disabled" : "")}>
                {newPage === 0 && <button type="button" className="page-link" aria-current="page"
                                          disabled={props.disabled} style={stilePageLink}
                                          aria-label={"Pagina ".concat(newPage + 1)}>{newPage + 1}</button>}
                {newPage > 0 && newPage !== lastPage &&
                <button type="button" className="page-link" onClick={() => changePage(newPage - 1)}
                        disabled={props.disabled} style={stilePageLink}
                        aria-label={"Vai alla pagina ".concat(newPage)}>{newPage}</button>}
                {totalPages === 2 && newPage === lastPage &&
                <button type="button" className="page-link" onClick={() => changePage(newPage - 1)}
                        disabled={props.disabled} style={stilePageLink}
                        aria-label={"Vai alla pagina ".concat(newPage)}>{newPage}</button>}
                {totalPages !== 2 && newPage === lastPage && newPage !== 0 &&
                <button type="button" className="page-link" onClick={() => changePage(newPage - 2)}
                        disabled={props.disabled} style={stilePageLink}
                        aria-label={"Vai alla pagina ".concat(newPage - 1)}>{newPage - 1}</button>}
            </li>
        )

        totalPages > 1 && pageNumbers.push(
            <li key={1} className={"page-item ".concat(props.disabled ? "disabled" : "")}>
                {newPage === 0 &&
                <button type="button" className="page-link" onClick={() => changePage(newPage + 1)}
                        disabled={props.disabled} style={stilePageLink}
                        aria-label={"Vai alla pagina ".concat(newPage + 2)}>{newPage + 2}</button>}
                {newPage > 0 && newPage !== lastPage &&
                <button type="button" className="page-link" aria-current="page"
                        disabled={props.disabled} style={stilePageLink}
                        aria-label={"Pagina ".concat(newPage + 1)}>{newPage + 1}</button>}
                {totalPages === 2 && newPage === lastPage &&
                <button type="button" className="page-link" aria-current="page"
                        disabled={props.disabled} style={stilePageLink}
                        aria-label={"Pagina ".concat(newPage + 1)}>{newPage + 1}</button>}
                {totalPages !== 2 && newPage === lastPage &&
                <button type="button" className="page-link" onClick={() => changePage(newPage - 1)}
                        disabled={props.disabled} style={stilePageLink}
                        aria-label={"Vai alla pagina ".concat(newPage)}>{newPage}</button>}
            </li>
        )

        totalPages > 2 && pageNumbers.push(
            <li key={2} className={"page-item ".concat(props.disabled ? "disabled" : "")}>
                {newPage === 0 &&
                <button type="button" className="page-link" onClick={() => changePage(newPage + 2)}
                        disabled={props.disabled} style={stilePageLink}
                        aria-label={"Vai alla pagina ".concat(newPage + 3)}>{newPage + 3}</button>}
                {newPage > 0 && newPage !== lastPage &&
                <button type="button" className="page-link" onClick={() => changePage(newPage + 1)}
                        disabled={props.disabled} style={stilePageLink}
                        aria-label={"Vai alla pagina ".concat(newPage + 2)}>{newPage + 2}</button>}
                {newPage === lastPage &&
                <button type="button" className="page-link" aria-current="page"
                        disabled={props.disabled} style={stilePageLink}
                        aria-label={"Pagina ".concat(newPage + 1)}>{newPage + 1}</button>}
            </li>
        )

        let toRender =
            <div style={{float: "right"}} className={" fit-width"}>
            <ul className="pagination mt-2">
                <li className={"page-item ".concat(props.disabled ? "disabled" : "")}>
                    <button type="button" className="page-link"
                            disabled={props.disabled || newPage === 0}
                            aria-label={"Vai alla prima pagina"}
                            onClick={() => newPage === 0 ? null : changePage(0)}
                            style={{...stilePageLink, cursor: newPage === 0 ? "auto" : "pointer"}}>
                            <span style={{fontFamily: "Arial", opacity: newPage === 0 ? "0.5" : "1"}}>
                                Prima
                            </span>
                    </button>
                </li>
                <li className={"page-item ".concat(props.disabled ? "disabled" : "")}>
                    <button type="button" className="page-link"
                            disabled={props.disabled || newPage === 0}
                            aria-label={"Pagina precedente"}
                            onClick={() => newPage === 0 ? null : changePage(newPage - 1)}
                            style={{...stilePageLink, cursor: newPage === 0 ? "auto" : "pointer"}}>
                            <span className="sr-only" style={{fontFamily: "Arial"}}>
                                Pagina precedente
                            </span>
                        <svg style={{opacity: page === lastPage ? "0.5" : "1"}} xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                             className="bi bi-chevron-left" viewBox="0 0 16 16">
                            <path fillRule="evenodd"
                                  d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"/>
                        </svg>
                    </button>
                </li>
                {pageNumbers}
                <li className={"page-item ".concat(props.disabled ? "disabled" : "")}>
                    <button type="button" className="page-link"
                            disabled={props.disabled || newPage === lastPage}
                            aria-label={"Pagina successiva"}
                            onClick={() => newPage === lastPage ? null : changePage(newPage + 1)}
                            style={{...stilePageLink, cursor: newPage === lastPage ? "auto" : "pointer"}}>
                        <span className="sr-only">Pagina successiva</span>
                        <svg style={{opacity: page === lastPage ? "0.5" : "1"}} xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                             className="bi bi-chevron-right" viewBox="0 0 16 16">
                            <path fillRule="evenodd"
                                  d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
                        </svg>
                    </button>
                </li>
                <li className={"page-item ".concat(props.disabled ? "disabled" : "")}>
                    <button type="button" className="page-link"
                            disabled={props.disabled || newPage === lastPage}
                            aria-label={"Vai all'ultima pagina"}
                            onClick={() => newPage === lastPage ? null : changePage(lastPage)}
                            style={{...stilePageLink, cursor: newPage === lastPage ? "auto" : "pointer"}}>
                            <span style={{fontFamily: "Arial", opacity: newPage === lastPage ? "0.5" : "1"}}>
                                Ultima
                            </span>
                    </button>
                </li>
            </ul>
        </div>
        setToRender(toRender)
    }


return (
    <div className={props.className}>
        {toRender}
    </div>
)
}

export default Pagination
